/** Wallet providers report user rejection as EIP-1193 code 4001. */
export function isUserRejection(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const code = (error as { code?: unknown }).code;
  if (code === 4001 || code === "ACTION_REJECTED") return true;
  const message = (error as { message?: unknown }).message;
  return typeof message === "string" && /user rejected|user denied|request rejected/i.test(message);
}

/** MetaMask reports 4902 when the chain has not been added to the wallet. */
export function isUnrecognisedChain(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const code = (error as { code?: unknown }).code;
  if (code === 4902) return true;
  const nested = (error as { data?: { originalError?: { code?: unknown } } }).data?.originalError?.code;
  if (nested === 4902) return true;
  const message = (error as { message?: unknown }).message;
  return typeof message === "string" && /unrecognized chain id|chain.*not.*added/i.test(message);
}

export class WalletMissingError extends Error {
  readonly wallet: "phantom" | "metamask";

  constructor(wallet: "phantom" | "metamask") {
    super(wallet === "phantom" ? "Phantom was not detected." : "MetaMask was not detected.");
    this.name = "WalletMissingError";
    this.wallet = wallet;
  }
}

/** Turns any thrown wallet value into a short sentence fit for the UI. */
export function walletErrorMessage(error: unknown, fallback: string): string {
  if (isUserRejection(error)) return "You cancelled the request in your wallet.";
  if (error instanceof WalletMissingError) return error.message;
  if (error instanceof Error && error.message) {
    return error.message.split("\n")[0] ?? fallback;
  }
  return fallback;
}
